import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { Modal } from '@calendly/ui/components/modal';
import { Body, Header, Title } from '@calendly/ui/components/popup';
import { Sheet } from '@calendly/ui/components/sheet';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { useMemo, forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFetchManagedEventTypesQuery, selectAllManagedEventTypes } from '../api';
import { EventTypeCard } from './event_type_card';
import { managedEventsWithSlugConflictsSelector } from './selectors';
import { closeSlugConflictsPopup } from './slice';
const popupContainerCss = "p19rvhbz";
const PopupContainer = forwardRef((props, ref) => <Sheet ref={ref} {...props} className={classNames(popupContainerCss, props.className)} />);
const eventTypesWrapperCss = "eu60t8q";
const EventTypesWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(eventTypesWrapperCss, props.className)} />;
});
const footerCss = "f1uq431a";
const Footer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(footerCss, props.className)} />;
});
export const SlugConflictPopup = ({
  isOpen,
  onSubmit
}) => {
  const dispatch = useDispatch();
  const {
    data: {
      collection
    } = {},
    isSuccess
  } = useFetchManagedEventTypesQuery({
    onlyOrgOwned: true,
    pageSize: 1000
  }, {
    skip: !isOpen
  });
  const managedEventsWithSlugConflicts = useSelector(managedEventsWithSlugConflictsSelector);
  const managedEventsWithConflicts = useMemo(() => {
    if (!managedEventsWithSlugConflicts || !isSuccess) return [];
    const managedEvents = selectAllManagedEventTypes(collection);
    return managedEventsWithSlugConflicts.map(({
      slug,
      memberships
    }) => ({
      managedEvent: managedEvents.find(me => me.slug === slug),
      memberships
    }));
  }, [managedEventsWithSlugConflicts, isSuccess, collection]);
  const handleClose = () => {
    dispatch(closeSlugConflictsPopup());
  };
  return <Modal isOpen={isOpen} onClose={handleClose}>
      <PopupContainer>
        <Header>
          <Title>
            {I18n.t('publisher.organization.members.bulk_managed_events_applying.slug_conflict.title')}
          </Title>
        </Header>

        <Body>
          <BodyText>
            {I18n.t('publisher.organization.members.bulk_managed_events_applying.slug_conflict.line_1')}
          </BodyText>

          <EventTypesWrapper>
            {managedEventsWithConflicts.map(({
            managedEvent,
            memberships
          }) => <EventTypeCard key={managedEvent.id} managedEvent={managedEvent} memberships={memberships} />)}
          </EventTypesWrapper>

          <BodyText>
            {I18n.t('publisher.organization.members.bulk_managed_events_applying.slug_conflict.line_2')}
          </BodyText>
        </Body>

        <Footer>
          <Button decoration="ghost" onClick={handleClose}>
            {I18n.t('publisher.action.cancel')}
          </Button>
          <Button onClick={onSubmit}>
            {I18n.t('publisher.organization.managed_event_types.assign.slug_conflict.confirm')}
          </Button>
        </Footer>
      </PopupContainer>
    </Modal>;
};

require("./slug_conflict_popup.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./slug_conflict_popup.js");